var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"overline"},[_vm._v(" "+_vm._s(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey) || "--")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }